import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var SearchSuggestionChipWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  font-size: ", "px;\n  border: 1px solid ", ";\n  background-color: ", ";\n  padding: ", ";\n  margin: 0\n    ", " 0;\n  border-radius: ", "px;\n  cursor: ", ";\n  pointer-events: ", ";\n\n  :hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  display: flex;\n  font-size: ", "px;\n  border: 1px solid ", ";\n  background-color: ", ";\n  padding: ", ";\n  margin: 0\n    ", " 0;\n  border-radius: ", "px;\n  cursor: ", ";\n  pointer-events: ", ";\n\n  :hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s1;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.light;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a, _b;

  return "".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs, "px ").concat((_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xs, "px");
}, function (props) {
  var _a, _b;

  return "".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs, "px ").concat((_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xs, "px");
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.md;
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled ? 'none' : 'all';
}, function (props) {
  var _a;

  return props.hoverBackgroundColor ? props.hoverBackgroundColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.yellowLighter;
}, function (props) {
  var _a;

  return props.hoverBorderColor ? props.hoverBorderColor : (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.yellowLight;
});
var templateObject_1;
export { SearchSuggestionChipWrapper };